import PersonChip from '@sayyesschool/frontend/components/person-chip';
import { Flex, Label } from '@sayyesschool/frontend/ui-components';

export default function EnrollmentMeta({ enrollment }) {
    return (
        <section className="EnrollmentMeta">
            <Flex gap="small">
                <Label content="Менеджер" horizontal>
                    <PersonChip
                        key={enrollment.manager?.id}
                        imageUrl={enrollment.manager?.image?.url || enrollment.manager?.image?.src}
                        content={enrollment.manager?.fullname}
                    />
                </Label>

                {enrollment.teacher &&
                    <Label content="Преподаватель" horizontal>
                        <PersonChip
                            key={enrollment.teacher?.id}
                            imageUrl={enrollment.teacher?.image?.url || enrollment.teacher?.image?.src}
                            content={enrollment.teacher?.fullname}
                        />
                    </Label>
                }
            </Flex>
        </section>
    );
}